/** Шапка вложенной страницы: назад и заголовок.
 *
 * Кнопка обёрнута в 44×44 с отрицательным полем: иконка может быть 21px, но
 * цель нажатия — нет, а вёрстка при этом не съезжает.
 */
export function Header({ title, onBack, action }: {
  title: string;
  onBack: () => void;
  action?: React.ReactNode;
}) {
  return (
    <header style={{ display: "flex", alignItems: "center", gap: "var(--s-3)",
                     marginBottom: "var(--s-4)" }}>
      <button type="button" onClick={onBack} aria-label="Назад"
              style={{ width: 44, height: 44, marginLeft: -11, background: "none",
                       border: "none", cursor: "pointer", display: "flex",
                       alignItems: "center", justifyContent: "center" }}>
        <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="var(--text)"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M15 6l-6 6 6 6" />
        </svg>
      </button>
      <h1 style={{ fontSize: "var(--f-t2)", fontWeight: 700, letterSpacing: "-0.3px",
                   margin: 0, flexGrow: 1 }}>{title}</h1>
      {action}
    </header>
  );
}
